// BadgeList.tsx - Complete Updated Component
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { FaIdBadge, FaSearch, FaPrint } from "react-icons/fa"
import { FiMoreVertical } from "react-icons/fi"
import { useHistory } from "react-router-dom"
import { GetBadgeList, UpdateBadge, DeleteBadge, GenarateBadge, printBadge } from "../../../api/Webservices"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import { useUser } from "../../AdminUsers/UserContext"
import ConfirmationModal from "../../ReuseUI/ConfirmModel"
import SmallSpinner from "../../ReuseUI/Spinner"
import PrintPreviewModal from "./PrintPreviewModal"
import "../../Event/Coupons/Coupon.css"

const BadgeList = () => {
  const { checkPermission } = useUser()
  const history = useHistory()
  const [searchTerm, setSearchTerm] = useState("")
  const [badges, setBadges] = useState([])
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState(null)
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [badgeToDelete, setBadgeToDelete] = useState(null)
  const [openMenuId, setOpenMenuId] = useState(null)
  const [activeTab, setActiveTab] = useState("all")
  const [entriesPerPage, setEntriesPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  const handleNavige = () => {
    history.push("/events/admin/create/badge")
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
    setCurrentPage(1)
  }

  const filteredBadges = useMemo(() => {
    return badges.filter((badge) => {
      const matchesSearch = !searchTerm || badge.title.toLowerCase().includes(searchTerm.toLowerCase())
      const matchesTab =
        activeTab === "all" ||
        (activeTab === "active" && badge.status === "active") ||
        (activeTab === "inactive" && badge.status === "inactive")
      return matchesSearch && matchesTab
    })
  }, [badges, searchTerm, activeTab])

  const paginatedBadges = useMemo(() => {
    const startIndex = (currentPage - 1) * entriesPerPage
    return filteredBadges.slice(startIndex, startIndex + entriesPerPage)
  }, [filteredBadges, currentPage, entriesPerPage])

  const totalPages = Math.ceil(filteredBadges.length / entriesPerPage)

  const renderHeader = () => (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        padding: "16px 24px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div
          style={{
            width: "40px",
            height: "40px",
            backgroundColor: "#1e3a5f",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            fontSize: "18px",
          }}
        >
          <FaIdBadge />
        </div>
        <h2
          style={{
            margin: 0,
            fontSize: "20px",
            fontWeight: "600",
            color: "#1f2937",
          }}
        >
          Badge
        </h2>
      </div>
      <button
        onClick={handleNavige}
        style={{
          backgroundColor: "#1e3a5f",
          color: "#ffffff",
          border: "none",
          borderRadius: "8px",
          padding: "10px 20px",
          fontSize: "14px",
          fontWeight: "500",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        + Create Badge
      </button>
    </div>
  )

  const renderFilters = () => {
    const tabs = [
      { key: "all", label: "All", count: badges.length },
      { key: "active", label: "Active", count: badges.filter((b) => b.status === "active").length },
      { key: "inactive", label: "Inactive", count: badges.filter((b) => b.status === "inactive").length },
    ]

    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "10px 10px 0 0",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          padding: "16px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => {
                setActiveTab(tab.key)
                setCurrentPage(1)
              }}
              style={{
                padding: "8px 16px",
                borderRadius: "6px",
                border: "none",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                backgroundColor: activeTab === tab.key ? "#1e3a5f" : "transparent",
                color: activeTab === tab.key ? "#ffffff" : "#6b7280",
              }}
            >
              {tab.label} ({tab.count})
            </button>
          ))}
        </div>
        <div style={{ position: "relative", width: "220px" }}>
          <FaSearch
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#9ca3af",
              fontSize: "14px",
            }}
          />
          <input
            type="text"
            placeholder="Search badges..."
            value={searchTerm}
            onChange={handleSearch}
            style={{
              width: "100%",
              padding: "10px 12px 10px 36px",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              fontSize: "14px",
              outline: "none",
              backgroundColor: "#ffffff",
            }}
          />
        </div>
      </div>
    )
  }

  const StatusToggle = ({ status, badgeId, badgeTemplate, BadgeTitle }) => {
    const [currentStatus, setCurrentStatus] = useState(status)
    const [isLoading, setIsLoading] = useState(false)

    const handleToggle = async () => {
      setIsLoading(true)
      const newStatus = currentStatus === "active" ? 0 : 1
      try {
        const payload = {
          id: badgeId,
          status: newStatus,
          title: BadgeTitle,
          template: badgeTemplate,
        }
        const res = await UpdateBadge(payload)
        if (res && res.success) {
          setCurrentStatus(newStatus === 1 ? "active" : "inactive")
          setBadges((prev) =>
            prev.map((b) => (b.id === badgeId ? { ...b, status: newStatus === 1 ? "active" : "inactive" } : b)),
          )
  showToast(
  `Badge ${newStatus === 1 ? "activated" : "deactivated"} successfully!`,
  newStatus === 1 ? "success" : "error"
)

        } else {
          showToast(res.message || "Failed to update status", "error")
        }
      } catch (error) {
        console.error("Error updating badge status:", error)
        showToast("Failed to update status. Please try again.", "error")
      } finally {
        setIsLoading(false)
      }
    }

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <button
          onClick={handleToggle}
          disabled={isLoading}
          style={{
            width: "44px",
            height: "24px",
            borderRadius: "12px",
            border: "none",
            cursor: isLoading ? "not-allowed" : "pointer",
            backgroundColor: currentStatus === "active" ? "#1e3a5f" : "#d1d5db",
            position: "relative",
            transition: "background-color 0.2s",
            opacity: isLoading ? 0.6 : 1,
          }}
        >
          <div
            style={{
              width: "18px",
              height: "18px",
              borderRadius: "50%",
              backgroundColor: "#ffffff",
              position: "absolute",
              top: "3px",
              left: currentStatus === "active" ? "23px" : "3px",
              transition: "left 0.2s",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
            }}
          />
        </button>
        {isLoading && <SmallSpinner size={14} />}
      </div>
    )
  }

  const BadgeActions = ({ badge, openMenuId, setOpenMenuId }) => {
    const showMenu = openMenuId === badge.id
    const containerRef = useRef(null)

    const handleToggle = () => {
      setOpenMenuId(showMenu ? null : badge.id)
    }

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
          setOpenMenuId(null)
        }
      }
      if (showMenu) {
        document.addEventListener("mousedown", handleClickOutside)
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [showMenu])

    const handleEditClick = async () => {
      history.push("/events/admin/create/badge", {
        state: { isEdit: true, badge: badge._originalData },
      })
      setOpenMenuId(null)
    }

    const handleDeleteClick = async () => {
      setBadgeToDelete(badge)
      setShowDeleteConfirmation(true)
      setOpenMenuId(null)
    }

    return (
      <div style={{ position: "relative" }} ref={containerRef}>
        <div
          onClick={handleToggle}
          style={{
            cursor: "pointer",
            padding: "8px",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FiMoreVertical style={{ fontSize: "18px", color: "#6b7280" }} />
        </div>
        {showMenu && (
          <div
            style={{
              position: "absolute",
              right: "0",
              top: "100%",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              border: "1px solid #e5e7eb",
              minWidth: "140px",
              zIndex: 1000,
              overflow: "hidden",
            }}
          >
            <div
              onClick={handleEditClick}
              style={{
                padding: "10px 16px",
                fontSize: "14px",
                color: "#374151",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
            >
              <i className="fa fa-edit"></i> Edit
            </div>
            <div
              onClick={handleDeleteClick}
              style={{
                padding: "10px 16px",
                fontSize: "14px",
                color: "#dc2626",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#fef2f2")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
            >
              <i className="fa fa-trash"></i> Delete
            </div>
          </div>
        )}
      </div>
    )
  }

  const GenerateButton = ({ badge }) => {
    const [isGenerating, setIsGenerating] = useState(false)

    const handleGenerate = async () => {
      setIsGenerating(true)
      try {
        const payload = {
          id: badge.id,
          event_id: badge.event_id,
          event_ticket: badge.event_ticket || [0],
        }
        const res = await GenarateBadge(payload)
        if (res && res.success) {
          showToast("Badge generated successfully!", "success")
        } else {
          showToast(res.message || "Failed to generate badge", "error")
        }
      } catch (error) {
        console.error("Error generating badge:", error)
        showToast("Failed to generate badge. Please try again.", "error")
      } finally {
        setIsGenerating(false)
      }
    }

    return (
      <button
        onClick={handleGenerate}
        disabled={isGenerating}
        style={{
          backgroundColor: "#1e3a5f",
          color: "#ffffff",
          border: "none",
          borderRadius: "6px",
          padding: "6px 14px",
          fontSize: "13px",
          fontWeight: "500",
          cursor: isGenerating ? "not-allowed" : "pointer",
          minWidth: "80px",
          opacity: isGenerating ? 0.6 : 1,
        }}
      >
        {isGenerating ? <SmallSpinner size={14} /> : "Generate"}
      </button>
    )
  }

  const PrintButton = ({ badge }) => {
    const [isPrinting, setIsPrinting] = useState(false)
    const [showPreview, setShowPreview] = useState(false)
    const [previewBadges, setPreviewBadges] = useState([])

    const handlePrinting = async () => {
      setIsPrinting(true)
      try {
        const payload = {
          id: badge.id,
          event_id: badge.event_id,
          event_ticket: badge.event_ticket || [0],
        }
        const res = await printBadge(payload)
        if (res && res.success) {
          setPreviewBadges(res.badge || [res])
          setShowPreview(true)
          showToast("Badge loaded successfully!", "success")
        } else {
          showToast(res.message || "Failed to load badge", "error")
        }
      } catch (error) {
        console.error("Error loading badge:", error)
        showToast("Failed to load badge. Please try again.", "error")
      } finally {
        setIsPrinting(false)
      }
    }

    return (
      <>
        <button
          onClick={handlePrinting}
          disabled={isPrinting}
          style={{
            backgroundColor: "#f3f4f6",
            color: "#374151",
            border: "1px solid #e5e7eb",
            borderRadius: "6px",
            padding: "8px 12px",
            fontSize: "16px",
            cursor: isPrinting ? "not-allowed" : "pointer",
            opacity: isPrinting ? 0.6 : 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          title="Print Badge"
        >
          {isPrinting ? <SmallSpinner size={14} /> : <FaPrint />}
        </button>
        <PrintPreviewModal show={showPreview} badges={previewBadges} onClose={() => setShowPreview(false)} />
      </>
    )
  }

  const LoadingSpinner = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "4px solid #e5e7eb",
          borderTop: "4px solid #1e3a5f",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      ></div>
      <p style={{ marginTop: "16px", color: "#6b7280", fontSize: "14px" }}>Loading badges...</p>
    </div>
  )

  const renderDataTable = () => (
    <div style={{ marginBottom: "24px" }}>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "0 0 10px 10px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        {apiError && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "12px 24px",
              backgroundColor: "#fef2f2",
              borderBottom: "1px solid #fecaca",
              color: "#991b1b",
              fontSize: "14px",
            }}
          >
            <i className="fa fa-exclamation-triangle"></i>
            {apiError}
          </div>
        )}

        <div style={{ padding: "16px 24px", borderBottom: "1px solid #f3f4f6" }}>
          <div style={{ fontSize: "14px", color: "#374151", fontWeight: "500", marginBottom: "8px" }}>Show Entries</div>
          <select
            value={entriesPerPage}
            onChange={(e) => {
              setEntriesPerPage(Number(e.target.value))
              setCurrentPage(1)
            }}
            style={{
              padding: "8px 12px",
              border: "1px solid #e5e7eb",
              borderRadius: "6px",
              fontSize: "14px",
              color: "#374151",
              backgroundColor: "#ffffff",
              cursor: "pointer",
              minWidth: "80px",
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={25}>25</option>
          </select>
        </div>

        <div style={{ padding: "0" }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
                    <th
                      style={{
                        padding: "16px 24px",
                        textAlign: "left",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                    >
                      Badge Name
                    </th>
                    <th
                      style={{
                        padding: "16px 24px",
                        textAlign: "left",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                    >
                      Created 
                    </th>
                    <th
                      style={{
                        padding: "16px 24px",
                        textAlign: "left",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        padding: "16px 24px",
                        textAlign: "left",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                    >
                      Generate
                    </th>
                    <th
                      style={{
                        padding: "16px 24px",
                        textAlign: "left",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                    >
                      Print
                    </th>
                    <th
                      style={{
                        padding: "16px 24px",
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#374151",
                        width: "60px",
                      }}
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedBadges.length === 0 ? (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ padding: "48px 24px", textAlign: "center", color: "#6b7280", fontSize: "14px" }}
                      >
                        No badges found.
                      </td>
                    </tr>
                  ) : (
                    paginatedBadges.map((badge) => (
                      <tr
                        key={badge.id}
                        style={{ borderBottom: "1px solid #f3f4f6" }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                      >
                        <td style={{ padding: "16px 24px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                            <div
                              style={{
                                width: "36px",
                                height: "36px",
                                backgroundColor: "#fff7ed",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#ea580c",
                                fontSize: "16px",
                              }}
                            >
                              <FaIdBadge />
                            </div>
                            <div style={{ fontSize: "14px", fontWeight: "500", color: "#1f2937" }}>{badge.title}</div>
                          </div>
                        </td>
                        <td style={{ padding: "16px 24px", fontSize: "14px", color: "#6b7280" }}>{badge.created_at}</td>
                        <td style={{ padding: "16px 24px" }}>
                          <StatusToggle
                            status={badge.status}
                            badgeId={badge.id}
                            BadgeTitle={badge.title}
                            badgeTemplate={badge.template}
                          />
                        </td>
                        <td style={{ padding: "16px 24px" }}>
                          <GenerateButton badge={badge} />
                        </td>
                        <td style={{ padding: "16px 24px" }}>
                          <PrintButton badge={badge} />
                        </td>
                        <td style={{ padding: "16px 24px", textAlign: "center" }}>
                          <BadgeActions badge={badge} openMenuId={openMenuId} setOpenMenuId={setOpenMenuId} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div
          style={{
            padding: "16px 24px",
            borderTop: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ fontSize: "14px", color: "#6b7280" }}>
            Showing {filteredBadges.length === 0 ? 0 : (currentPage - 1) * entriesPerPage + 1} to{" "}
            {Math.min(currentPage * entriesPerPage, filteredBadges.length)} of {filteredBadges.length} entries
          </span>
          <div style={{ display: "flex", alignItems: "center", gap: "0" }}>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                padding: "8px 16px",
                fontSize: "14px",
                color: currentPage === 1 ? "#9ca3af" : "#6b7280",
                backgroundColor: "#ffffff",
                border: "1px solid #e5e7eb",
                borderRadius: "6px 0 0 6px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              Previous
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: "8px 14px",
                  fontSize: "14px",
                  color: currentPage === page ? "#ffffff" : "#6b7280",
                  backgroundColor: currentPage === page ? "#1e3a5f" : "#ffffff",
                  border: "1px solid",
                  borderColor: currentPage === page ? "#1e3a5f" : "#e5e7eb",
                  cursor: "pointer",
                  marginLeft: "-1px",
                }}
              >
                {page}
              </button>
            ))}
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages || totalPages === 0}
              style={{
                padding: "8px 16px",
                fontSize: "14px",
                color: currentPage === totalPages || totalPages === 0 ? "#9ca3af" : "#6b7280",
                backgroundColor: "#ffffff",
                border: "1px solid #e5e7eb",
                borderRadius: "0 6px 6px 0",
                cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer",
                marginLeft: "-1px",
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "16px", padding: "12px 0", color: "#6b7280", fontSize: "14px" }}>
        Showing 1 to {Math.min(entriesPerPage, filteredBadges.length)} records of {badges.length}
      </div>
    </div>
  )

  const loadBadges = () => {
    setLoading(true)
    GetBadgeList()
      .then((res) => {
        if (res && res.data) {
          const formattedBadges = res.data.map((badge) => ({
            id: badge.id,
            title: badge.title,
            template: badge.template,
            event_id: badge.event_id,
            event_ticket: badge.event_ticket,
            badge_size: badge.badge_size,       
  default_bg: badge.default_bg,
            created_at: new Date(badge.created_at).toLocaleDateString("en-US", {
              day: "numeric",
              month: "short",
              year: "numeric",
            }),
            status: badge.status === 1 ? "active" : "inactive",
            _originalData: badge,
          }))
          setBadges(formattedBadges)
        }
        setLoading(false)
        setApiError(null)
      })
      .catch((err) => {
        console.error("Error loading badges:", err)
        setLoading(false)
        setApiError("Failed to load badges. Please try again.")
      })
  }

  useEffect(() => {
    loadBadges()
  }, [])

  const handleDeleteConfirmed = async () => {
    if (!badgeToDelete) return
    try {
      const res = await DeleteBadge(badgeToDelete.id)
      if (res && res.success === true) {
        showToast("Badge deleted successfully!", "success")
        loadBadges()
      } else {
        showToast(res.message || "Failed to delete badge", "error")
      }
    } catch (error) {
      console.error("Error deleting badge:", error)
      showToast("Failed to delete badge. Please try again.", "error")
    }
    setBadgeToDelete(null)
    setShowDeleteConfirmation(false)
  }

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#f8fafc",
          padding: "24px",
        }}
      >
        <ToastMessage />
        {renderHeader()}
        {renderFilters()}
        {renderDataTable()}
        <ConfirmationModal
          show={showDeleteConfirmation}
          title="Delete Badge"
          message={`Are you sure you want to delete the badge "${badgeToDelete?.title}"? This action cannot be undone.`}
          confirmButtonText="Delete"
          confirmButtonVariant="danger"
          onConfirm={handleDeleteConfirmed}
          onCancel={() => {
            setShowDeleteConfirmation(false)
            setBadgeToDelete(null)
          }}
        />
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  )
}

export default BadgeList
